import axios from '../axios';
import {GET_ACCOUNT_TYPE_LIST, GET_PRIMARY_ACCOUNT_TYPE_LIST} from "../constants/ApiConstants";

export function getAccountTypes() {
  return axios.get(GET_ACCOUNT_TYPE_LIST).then((response) => response.data);
}

export function getPrimaryAccountTypes() {
  return axios.get(GET_PRIMARY_ACCOUNT_TYPE_LIST).then((response) => response.data);
}